import { THEME } from '../configs/global';
import moment from 'moment';

export const isEmptyObj = obj => Object.keys(obj).length === 0 && obj.constructor === Object;
export const getLeadingZero = str => str.toString().length === 1 ? '0' + str : str;
export const getTime = obj => obj ? THEME.TIME_FORMAT === '12' ? moment(obj).format("h:mm a") : moment(obj).format("HH:mm") : null;





// WEBPACK FOOTER //
// ./src/helpers/Helpers.js